import { createFileRoute } from '@tanstack/react-router'
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";

function ResetPassword() {
  return <ResetPasswordForm />;
}

export const Route = createFileRoute('/(authentication)/(auth)/reset-password/')({
  component: ResetPassword,
})
